module.exports = __webpack_public_path__ + "static/media/084da50b-2e07-4310-a7ef-6bcd77070965.6b04e4a0.jpg";